const allowedProtocols = new Set(['http:', 'https:'])

const getAbsoluteUrl = (url: string): URL | undefined => {
  try {
    return new URL(url, 'https://example.com')
  } catch {
    return undefined
  }
}

export const urlGetRelativeUrl = (url: URL | string): string | undefined => {
  const absoluteUrl = typeof url === 'string' ? getAbsoluteUrl(url) : url

  if (absoluteUrl && allowedProtocols.has(absoluteUrl.protocol)) {
    const { hash, pathname, search } = absoluteUrl

    return `${pathname}${search}${hash}`
  }

  return undefined
}
